/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Preview_UnavailableInputs */

const en_common_preview_unavailable = /** @type {(inputs: Common_Preview_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preview unavailable`)
};

const es_common_preview_unavailable = /** @type {(inputs: Common_Preview_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vista previa no disponible`)
};

/**
* | output |
* | --- |
* | "Preview unavailable" |
*
* @param {Common_Preview_UnavailableInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const common_preview_unavailable = /** @type {((inputs?: Common_Preview_UnavailableInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Preview_UnavailableInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_common_preview_unavailable(inputs)
	return en_common_preview_unavailable(inputs)
});